import React, { FC } from "react";

type IProps = {
  width?: string;
  height?: string;
  color?: string;
};

const Wave: FC<IProps> = ({ width, height, color }) => {
  return (
    <svg
      width={width ? width : "40"}
      height={height ? height : "40"}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="13" y="15" width="2" height="10" rx="1" fill="#FD8533" />
      <rect x="25" y="15" width="2" height="10" rx="1" fill="#FD8533" />
      <rect x="21" y="16" width="2" height="8" rx="1" fill="#FD8533" />
      <rect x="17" y="12" width="2" height="16" rx="1" fill="#FD8533" />
      <rect
        x="1"
        y="1"
        width="38"
        height="38"
        rx="19"
        stroke="#FD8533"
        stroke-width="2"
      />
    </svg>
  );
};

export default Wave;
